
  <sm-title-bar  pageTitle="Messages"></sm-title-bar>


  
  
  
  <div class="chat-container" *ngIf="!loader">
    <mat-card appearance="outlined" class="sidebar" *ngIf="showLeftPanel">
      <div class="search_bart">
      <mat-form-field  appearance="outline">
        <mat-label>Search by name</mat-label>
        <input matInput #input [(ngModel)]="searchKey">
      </mat-form-field>
    </div>
      <mat-list style="padding: 0px 0px;
      overflow: auto;
      height: 70vh;" *ngIf="chatThreads.length > 0"> 
          <!-- <div matLine>Name</div> -->
          <div *ngFor="let thread of chatThreads | messageFilter: searchKey" (click)="selectThread(thread)" class="chatxx chatTCLS scrollbox-content" [ngClass]="{'selected': thread.isSelected == 1}"  >
   
            <div class="ultra_sectionmk">
            <div class="left_cat" style="padding-top: 5px;padding-right: 0px;">
              <img [src]="thread.senderInfo.imgThumbUrl" onerror="this.src='../../../../assets/images/user-avatar.svg'" style="height: 50px; width: 50px; border-radius: 50%;object-fit: cover;" alt="" *ngIf="thread.isSender == 0">
              <img [src]="thread.receiverInfo.imgThumbUrl" onerror="this.src='../../../../assets/images/user-avatar.svg'" style="height: 50px; width: 50px;border-radius: 50%;object-fit: cover;" alt="" *ngIf="thread.isSender == 1">
            </div>
            <div class="right_chatx" style="padding-right: 0px;">
              <div class="thread" style="display: flex;align-items: center;width: 100%;width: 200px;">
                <span style="flex: 1; font-size: 1rem;font-weight: normal; color:#222" *ngIf="thread.isSender == 0">{{ thread.senderInfo.name.length > 15 ? thread.senderInfo.name.substring(0,15) + "..." : thread.senderInfo.name  }}</span>
                <span style="flex: 1; font-size: 1rem;font-weight: normal; color:#222" *ngIf="thread.isSender == 1">{{ thread.receiverInfo.name.length > 15 ? thread.receiverInfo.name.substring(0,15) + "..." : thread.receiverInfo.name }}</span>
              </div>
              <div style=" width: 200px;">
                <p style="margin: -5px 0 0px;font-weight: normal; color:#333">(with {{thread.entity_name.length > 20 ? thread.entity_name.substring(0,20) + "..." : thread.entity_name}})</p>
              </div>
              <div style="padding: 2px 1px 15px;color: #747272;width: 200px;">
              {{thread.lastMessage.length > 25 ? thread.lastMessage.substring(0,25) + "..." : thread.lastMessage}}
              </div>
            </div>
           
          </div>
          <div class="lats_date_name">
            <p style="margin: 0; color: #747272; font-size: 11px;line-break: auto;word-break: break-all; ">{{thread.lastMTime}}</p>
            <div class="msg_status" *ngIf="thread.read_status > 0"></div>
          </div>
          </div>
        
      </mat-list>
      <div class="chat-threads scrollbox" style="visibility: visible;" *ngIf="chatThreads.length == 0">
        <div style="text-align: center;
        color: #7c7c7c;
        padding-top: 240px;">
        <div class="message_yet_sdr">
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M480.052 369.741c49.476-69.417 41.913-164.522-25.665-226.473-30.877-28.305-70.24-45.926-112.761-50.847a15.224 15.224 0 0 0-.833-.958C303.802 53.038 250.658 31 194.988 31 89.049 31 0 109.933 0 211c0 35.435 11.007 69.404 31.916 98.741L2.707 401.447a14.999 14.999 0 0 0 21.09 17.923l88.827-45.167c18.242 7.855 37.586 13.009 57.618 15.354C208.884 430.193 262.315 451 316.98 451c28.416 0 56.729-5.791 82.36-16.798l88.831 45.169a14.973 14.973 0 0 0 6.795 1.629c10.123 0 17.38-9.865 14.295-19.553zm-361.374-25.72a14.997 14.997 0 0 0-13.233.179l-63.267 32.17 20.66-64.866a14.998 14.998 0 0 0-2.473-13.788C40.499 272.286 29.998 242.301 29.998 211c0-82.71 74.014-150 164.99-150 36.636 0 71.905 11.099 100.514 31.086-96.348 9.688-173.51 84.942-173.51 178.914 0 29.228 7.492 57.366 21.617 82.576a173.556 173.556 0 0 1-24.931-9.555zm287.845 60.178a14.998 14.998 0 0 0-13.233-.178C369.905 415.129 343.518 421 316.98 421c-90.976 0-164.99-67.29-164.99-150s74.014-150 164.99-150 164.99 67.29 164.99 150c0 31.301-10.501 61.286-30.368 86.715a15.004 15.004 0 0 0-2.473 13.788l20.66 64.866z" fill="#767676" opacity="1" data-original="#000000" class=""></path><circle cx="255.984" cy="271" r="15" fill="#767676" opacity="1" data-original="#000000" class=""></circle><circle cx="315.981" cy="271" r="15" fill="#767676" opacity="1" data-original="#000000" class=""></circle><circle cx="375.977" cy="271" r="15" fill="#767676" opacity="1" data-original="#000000" class=""></circle></g></svg>
        </div>
          <p>No messages yet.</p>
        </div>

      </div>
    </mat-card>
  
    <mat-card appearance="outlined" class="chat-window" *ngIf="selectedThread.length > 0 && !chatLoader && showRightPanel">
      <div class="chat-header mesheader">
        <div class="header" style="height: 52px;padding-top: 6px;">
          <mat-icon (click)="goBackToThread()" class="og" style="position: relative; top: 9px; margin-right: 10px;" *ngIf="!showLeftPanel">arrow_back</mat-icon>
          <span *ngIf="(myProfileHash == selectedThread[0].senderInfo.hash_id && myProfileHash != selectedThread[0].receiverInfo.hash_id) || (myProfileHash != selectedThread[0].senderInfo.hash_id && myProfileHash == selectedThread[0].receiverInfo.hash_id)">

            <img *ngIf="myProfileHash == selectedThread[0].senderInfo.hash_id" [src]="selectedThread[0].receiverInfo.imgThumbUrl" onerror="this.src='../../../../assets/images/user-avatar.svg'" style="height: 40px; width: 40px; border-radius: 50%;     object-fit: cover;" alt="">
            <img *ngIf="myProfileHash == selectedThread[0].receiverInfo.hash_id" [src]="selectedThread[0].senderInfo.imgThumbUrl" onerror="this.src='../../../../assets/images/user-avatar.svg'" style="height: 40px; width: 40px; border-radius: 50%;     object-fit: cover;" alt="">
          </span>
            <span *ngIf="myProfileHash == selectedThread[0].senderInfo.hash_id && myProfileHash == selectedThread[0].receiverInfo.hash_id">
            <img [src]="selectedThread[0].senderInfo.imgThumbUrl" onerror="this.src='../../../../assets/images/user-avatar.svg'" style="height: 40px; width: 40px; border-radius: 50%;     object-fit: cover;" alt="">
          </span>
          <span *ngIf="(myProfileHash == selectedThread[0].senderInfo.hash_id && myProfileHash != selectedThread[0].receiverInfo.hash_id) || (myProfileHash != selectedThread[0].senderInfo.hash_id && myProfileHash == selectedThread[0].receiverInfo.hash_id)">

            <span style="margin-left: 10px;position: relative;top: -10px;font-weight: normal;font-size: 16px;"*ngIf="myProfileHash == selectedThread[0].senderInfo.hash_id"> {{ selectedThread[0].receiverInfo.name }}</span>
            <span style="margin-left: 10px;position: relative;top: -10px;font-weight: normal;font-size: 16px;"*ngIf="myProfileHash == selectedThread[0].receiverInfo.hash_id"> {{ selectedThread[0].senderInfo.name }}</span>
          </span>
          <span *ngIf="myProfileHash == selectedThread[0].senderInfo.hash_id && myProfileHash == selectedThread[0].receiverInfo.hash_id">
            <span style="margin-left: 10px;position: relative;top: -10px;font-weight: normal;font-size: 16px;"*ngIf="myProfileHash == selectedThread[0].receiverInfo.hash_id"> {{ selectedThread[0].senderInfo.name }}</span>
          </span>
          
          <p style="font-size: 14px;position: relative;top: -19px;left: 88px;font-weight: 500;width: fit-content;color: #747272;">(with {{sThread.entity_name.length > 15 ? sThread.entity_name.substring(0,15) + "..." : sThread.entity_name }})</p>
        </div>
        <div class="refres_btn_srd">
          <button class="refres_btn_srd" mat-icon-button aria-label="Refresh" (click)="refresh()">
            <mat-icon>refresh</mat-icon>
          </button>
          
        </div>
      </div>
      <div class="chat-body">
        <div class="chat_sectionm">
        <div>
          <div class="bns_pliud_aas" >
            <div class="asde" >
                <div class="scrollbox hrklm" id="divExample" #scrollableDiv>
                    <div class="chat-history scrollbox-content" >
                        <ul>
                            <li class="clearfix" *ngFor="let message of selectedThread; let i=index;"> 
                              <!-- message i received -->
                                <div class="bgmes_thy" *ngIf="message.iSent == 0">
                                    <div class="message my-message" style="position: relative;" [ngClass]="{'custcls2': message.status != 1}">
                                      
                                        <div class="myDIV" [ngStyle]="{'margin-top': message.status == 1 ? '8px' : '0px'}">
                                          <p *ngIf="message.status == 1" class="bnstextspace">{{message.message}}</p>
                                          <p *ngIf="message.status != 1" class="bnstextspace">This message was deleted</p>
                                        </div>
                                        <div style="text-align: right;
                                        font-size: 12px;
                                        color: #282828;
                                        padding: 25px 0px 0px 0px;">
                                          <span>{{message.creationTime | date:'dd-MM-yyyy, h:mm a':'UTC+0530'}}
                                          </span>
                                        </div>
                                    </div>
                                </div>
                                <!-- message i sent -->
                                <div class="bgmes_thy" *ngIf="message.iSent == 1">
                                  <div class="message other-message float-right" style="position: relative;" [ngClass]="{'custcls': message.status != 1}"  (mouseenter)="onMouseEnter(message)"
                                  (mouseleave)="onMouseLeave(message)">
                                    <button
                                    *ngIf="message.status == 1"
                                    style="top: -6px;
                                    right: 0px;
                                    position: absolute;
                                    color: #222 !important;
                                    "
                                     [style.display]="(message.showmenu && message.showmenu == true)  ? 'block' : 'none'"
                                    mat-icon-button
                                    [matMenuTriggerFor]="menuopt"
                                    class="profile_button"
                                    class="opt"
                                  >
                                    <mat-icon class="material-icons-outlined" style="font-size: 20px; color: #222222;"
                                      >more_horiz</mat-icon
                                    >
                                  </button>
                                  <mat-menu #menuopt="matMenu">
                                    <button mat-menu-item (click)="deleteMessage(message.subMsgHash)">
                                      <span class="menu_text">Delete</span>
                                    </button>
                                  </mat-menu>
                                      <div class="myDIV" [ngStyle]="{'margin-top': message.status == 1 ? '8px' : '0px'}">
                                        <p *ngIf="message.status == 1" class="bnstextspace">{{message.message}}</p>
                                        <p *ngIf="message.status != 1" class="bnstextspace">This message was deleted</p>
                                      </div>
                                      <div style="text-align: right;
                                      font-size: 12px;
                                      color: #282828;
                                      padding: 25px 0px 0px 0px; ">
                                        <span>{{message.creationTime | date:'dd-MM-yyyy, h:mm a':'UTC+0530'}}</span>
                                      </div>
                                  </div>
                              </div>
                            </li>

                        

                            <div class="sd_mgr"></div>
                        </ul>
                    </div>
                </div>
            </div>
          
        </div>




        </div>
      </div>
      </div>
      <mat-form-field class="chat-footer mat-form-field-hide-placeholder" appearance="outline" style="width: 94%;">
        <textarea (keydown.enter)="sendMessage()"  placeholder="Write something" matInput [disabled]="textAreaDisabled" [(ngModel)]="message" style="height: 18px;resize: none;"></textarea>
        <button mat-icon-button matSuffix (click)="sendMessage()" *ngIf="!textAreaDisabled">
          <mat-icon>send</mat-icon>
        </button>
        <button mat-icon-button matSuffix  *ngIf="textAreaDisabled">
          <mat-spinner [diameter]="30" style="position: relative;
          
          top: 2px;  stroke: #fff;"></mat-spinner>
        </button>
      </mat-form-field>
    </mat-card>

      <div class="right-panel" *ngIf="(selectedThread.length == 0 || chatLoader) && showRightPanel" style=" overflow-x: hidden; overflow-y: hidden;">
        
        <div class="bns_pliud_aas" style="    padding-top: 0px;">
          <div class="asde" style="background: #eee;">
              <div class="" style=" overflow-y: auto;overflow-x: hidden" id="divExample" >
                  <div class="chat-history scrollbox-content">
                   
                    <div style="text-align: center;
                        height: 80vh;

                    display: flex;
                    justify-content: center;
                    align-items: center;" *ngIf="chatLoader">
                      <svg version="1.1" id="L4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve" style=" width: 130px;
                      height: 130px;
                      margin: 20px;
                      padding-left: 10px;
                      display:inline-block;">
                      <circle fill="#FFC107" stroke="none" cx="6" cy="50" r="4">
                        <animate
                          attributeName="opacity"
                          dur="1s"
                          values="0;1;0"
                          repeatCount="indefinite"
                          begin="0.1"/>    
                      </circle>
                      <circle fill="#FFC107" stroke="none" cx="26" cy="50" r="4">
                        <animate
                          attributeName="opacity"
                          dur="1s"
                          values="0;1;0"
                          repeatCount="indefinite" 
                          begin="0.2"/>       
                      </circle>
                      <circle fill="#FFC107" stroke="none" cx="46" cy="50" r="4">
                        <animate
                          attributeName="opacity"
                          dur="1s"
                          values="0;1;0"
                          repeatCount="indefinite" 
                          begin="0.3"/>     
                      </circle>
                      <circle fill="#FFC107" stroke="none" cx="66" cy="50" r="4">
                        <animate
                          attributeName="opacity"
                          dur="1s"
                          values="0;1;0"
                          repeatCount="indefinite" 
                          begin="0.3"/>     
                      </circle>
                      <circle fill="#FFC107" stroke="none" cx="86" cy="50" r="4">
                        <animate
                          attributeName="opacity"
                          dur="1s"
                          values="0;1;0"
                          repeatCount="indefinite" 
                          begin="0.3"/>     
                      </circle>
                    </svg>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        



    
      </div>
   
   
   
  </div>
  
  
